import { render, staticRenderFns } from "./TabProgAction.vue?vue&type=template&id=09131ddb"
import script from "./TabProgAction.vue?vue&type=script&lang=js"
export * from "./TabProgAction.vue?vue&type=script&lang=js"
import style0 from "./TabProgAction.vue?vue&type=style&index=0&id=09131ddb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports